<template>
  <div class="map-main">
    <div id="chinaMap" style="height: 100%;width: 100%;"></div>
  </div>
</template>
<script setup>
import * as echarts from 'echarts'
import chinaJson from './nationalData.json'
import {nextTick, onBeforeUnmount, onMounted, ref} from 'vue'
import {emitter} from '@/eventBus/eventBus'
let chartInstance = null;
function drawChina() {
  const dom = document.getElementById('chinaMap');
  if (echarts.getInstanceByDom(dom)) {
    echarts.dispose(dom);
  }
  chartInstance = echarts.init(dom);
  echarts.registerMap('china', chinaJson);
  const provinces = chinaJson.features.map(f => f.properties.name);
  // 配置选项
  const setOption = () => {
    const option = {
      series: [{
        type: 'map',
        map: 'china',
        roam: true,
        center: [105.194115019531, 35.582111640625],
        zoom: 1.7,
        scaleLimit: {
          min: 1.7,
          max: 2,
        },
        // 地图区域样式
        itemStyle: {
          color: '#bdd1e5',
          borderColor: '#fff',
          areaColor: '#bdd1e5',
          borderWidth: 1
        },
        label: {
          show: true,
          color: '#646262',
          fontSize: 12,
          formatter: (params) => {
            if (params.name.indexOf('黑龙江') > -1 || params.name.indexOf('内蒙古') > -1) {
              return params.name.slice(0, 3)
            }
            return params.name.slice(0, 2)
          }
        },
        emphasis: {
          itemStyle: {
            color: '#4fa7f9',
            areaColor: '#4fa7f9',
            borderColor: '#fff',
            borderWidth: 1
          }
        },
        // 为特定省份设置自定义标签位置
        data: provinces.map(name => {
          let item = { name };
          if (name === '甘肃省') {
            item.label = { offset: [40, 45] };
          } else if (name === '陕西省') {
            item.label = { offset: [-5, 20] };
          } else if (name === '河北省') {
            item.label = { offset: [-5, 20] };
          }
          return item;
        })
      }]
    };
    chartInstance.setOption(option,true);
    chartInstance.on('mouseover', (params) => {
      if (params.name) {
        emitter.emit('map-province-highlight', params.name);
      }
    });
    chartInstance.on('mouseout', () => {
      emitter.emit('map-province-highlight');
    });
  }
  setOption();
}
const highlightMapColor=async (province)=>{
  if (!chartInstance) return;
  await nextTick();
  if(province){
    chartInstance.dispatchAction({
      type: 'highlight',
      seriesIndex: 0,
      name: province
    });
  }else {
    chartInstance.dispatchAction({
      type: 'downplay',
      seriesIndex: 0
    });
  }
}
onMounted(() => {
  drawChina();
  // 监听窗口大小变化
  window.addEventListener('resize', handleResize);
  emitter.on('showMapColor', highlightMapColor)
    // 监听全屏切换（兼容不同浏览器前缀）
  document.addEventListener('fullscreenchange', handleFullscreenChange);
  document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
  document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
  document.addEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge
})
// 处理窗口/屏幕变化
const handleResize = () => {
  if (chartInstance) {
    chartInstance.resize(); // 重新渲染图表
  }
};

// 处理全屏状态变化（兼容不同浏览器）
const handleFullscreenChange = () => {
  handleResize();
};
onBeforeUnmount(() => {
  // 移除所有事件监听
  window.removeEventListener('resize', handleResize);
  document.removeEventListener('fullscreenchange', handleFullscreenChange);
  document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
  document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
  document.removeEventListener('MSFullscreenChange', handleFullscreenChange);

  // 销毁图表实例
  if (chartInstance) {
    chartInstance.dispose();
    chartInstance = null;
  }
  emitter.off('showMapColor');
});
</script>
<style scoped lang="scss">
.map-main {
  width: 100%;
  height: 100%;
}
</style>
